import { render, staticRenderFns } from "./recommend_content.vue?vue&type=template&id=4ecf8f00"
import script from "./recommend_content.vue?vue&type=script&lang=js"
export * from "./recommend_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports